import { useState } from 'react';
import { motion } from 'framer-motion';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
    }, 3000);
  };

  const inputClasses =
    'peer w-full bg-transparent border-0 border-b border-charcoal/20 px-0 py-3 font-sans text-charcoal placeholder-transparent focus:border-gold focus:ring-0 outline-none transition-colors duration-300';
  const labelClasses =
    'absolute left-0 -top-3 text-xs font-sans text-charcoal/40 transition-all duration-300 peer-placeholder-shown:top-3 peer-placeholder-shown:text-sm peer-focus:-top-3 peer-focus:text-xs peer-focus:text-gold';

  return (
    <motion.form
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      onSubmit={handleSubmit}
      className="space-y-8"
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
        <div className="relative">
          <input
            type="text"
            name="name"
            id="name"
            value={formData.name}
            onChange={handleChange}
            required
            className={inputClasses}
            placeholder="Full Name"
          />
          <label htmlFor="name" className={labelClasses}>
            Full Name
          </label>
        </div>
        <div className="relative">
          <input
            type="email"
            name="email"
            id="email"
            value={formData.email}
            onChange={handleChange}
            required
            className={inputClasses}
            placeholder="Email Address"
          />
          <label htmlFor="email" className={labelClasses}>
            Email Address
          </label>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
        <div className="relative">
          <input
            type="tel"
            name="phone"
            id="phone"
            value={formData.phone}
            onChange={handleChange}
            className={inputClasses}
            placeholder="Phone Number"
          />
          <label htmlFor="phone" className={labelClasses}>
            Phone Number
          </label>
        </div>
        <div className="relative">
          <select
            name="subject"
            id="subject"
            value={formData.subject}
            onChange={handleChange}
            required
            className={`${inputClasses} cursor-pointer ${!formData.subject ? 'text-charcoal/40' : ''}`}
          >
            <option value="">Select a subject</option>
            <option value="general">General Inquiry</option>
            <option value="project">Project Information</option>
            <option value="site-visit">Schedule Site Visit</option>
            <option value="investment">Investment Opportunity</option>
            <option value="career">Career Inquiry</option>
          </select>
          <label htmlFor="subject" className={`absolute left-0 -top-3 text-xs font-sans transition-all duration-300 ${formData.subject ? 'text-gold' : 'text-charcoal/40'}`}>
            Subject
          </label>
        </div>
      </div>

      <div className="relative">
        <textarea
          name="message"
          id="message"
          value={formData.message}
          onChange={handleChange}
          required
          rows={4}
          className={`${inputClasses} resize-none`}
          placeholder="Message"
        />
        <label htmlFor="message" className={labelClasses}>
          Your Message
        </label>
      </div>

      {submitted ? (
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          className="flex items-center justify-center gap-3 py-4 bg-emerald-50 text-emerald-700 font-sans"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <motion.path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ duration: 0.5 }}
            />
          </svg>
          <span className="text-sm font-medium">Message Sent Successfully!</span>
        </motion.div>
      ) : (
        <button type="submit" className="btn-premium-filled w-full sm:w-auto">
          <span className="flex items-center gap-2">
            Send Message
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </span>
        </button>
      )}
    </motion.form>
  );
};

export default ContactForm;
